import UsagePanel from "views/admin/dashboard/ai-spend/UsagePanel";

interface UsageTabProps {
  customerCompanyId: string;
}

/**
 * The company's AI usage and allowance (WP-70): the standing of any hard limit that applies to
 * it, then who and what in the company spent the tokens — by customer, source, workflow,
 * autonomous agent and job. Tenant plane only; the picker is the shared panel's.
 */
const UsageTab = ({ customerCompanyId }: UsageTabProps) => (
  <UsagePanel
    filter={{ customerCompanyId }}
    sections={[
      "allowance",
      "byCustomer",
      "bySource",
      "byWorkflow",
      "byAutonomousAgent",
      "topJobs",
    ]}
    compact
  />
);

export default UsageTab;
